import script from "./USuccessAdded.vue?vue&type=script&setup=true&lang=ts"
export * from "./USuccessAdded.vue?vue&type=script&setup=true&lang=ts"

import "./USuccessAdded.vue?vue&type=style&index=0&id=017123aa&lang=css"

const __exports__ = script;

export default __exports__